module.exports = __webpack_public_path__ + "img/calendar.c0cf8cc0.svg";